import { useEffect, useState } from "react";
import { adminApi } from "../../lib/adminApi";
import { api, money } from "../../lib/api";
import { Card, PageTitle, TextInput, TextArea, Btn, run } from "../../components/admin/AdminUI";
import { BrandingCard } from "../../components/admin/BrandingCard";

const FIELDS = [
  ["rate_per_mile", "Rate per mile ($)", "0.01"], ["minimum_price", "Minimum price ($)", "1"],
  ["long_distance_threshold_miles", "Long-distance threshold (miles)", "1"],
];

const PricingForm = () => {
  const [f, setF] = useState(null);
  const [sample, setSample] = useState(null);
  useEffect(() => { adminApi.get("/admin/settings/pricing").then((r) => setF(r.data)); }, []);
  if (!f) return <Card title="Pricing"><p className="text-sm text-slate-500">Loading…</p></Card>;
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v }));
  const save = async () => {
    const body = { ...Object.fromEntries(FIELDS.map(([k]) => [k, Number(f[k])])), long_distance_message: f.long_distance_message };
    const r = await run(() => adminApi.put("/admin/settings/pricing", body), "Pricing saved. Quotes use it immediately.");
    if (r) {
      setF(r.data);
      const q = await api.post("/quote", { pickup_zip: "83605", delivery_zip: "10001" });
      setSample(q.data);
    }
  };
  return (
    <Card title="Pricing" testid="pricing-settings">
      <p className="text-sm text-slate-600 mb-5">Price = the higher of the minimum price or rate × miles, rounded to the nearest dollar. Vehicle type, enclosed, inoperable and expedited don't change the price (expedited only shortens the transit estimate).</p>
      <div className="grid sm:grid-cols-3 gap-4">
        {FIELDS.map(([k, l, step]) => <TextInput key={k} label={l} type="number" step={step} value={f[k]} onChange={set(k)} testid={`pricing-${k.replace(/_/g, "-")}`} />)}
      </div>
      <TextInput className="mt-4" label="Long-distance message (shown above the threshold)" value={f.long_distance_message} onChange={set("long_distance_message")} testid="pricing-long-distance-message" />
      <div className="mt-6 flex flex-wrap items-center justify-between gap-3">
        {sample ? <p className="text-sm text-slate-700" data-testid="pricing-sample">Sample: 83605 → 10001 = <strong>{money(sample.estimate)}</strong> ({sample.miles.toLocaleString()} mi{sample.long_distance ? ", long-distance note shown" : ""})</p> : <span />}
        <Btn onClick={save} data-testid="pricing-save">Save pricing</Btn>
      </div>
    </Card>
  );
};

const BANK = [["bank_name", "Bank name"], ["account_name", "Account name / beneficiary"], ["account_number", "Account number"], ["routing_number", "Routing number (ABA)"], ["swift_code", "SWIFT / BIC"], ["bank_address", "Bank address"]];

const PaymentForm = () => {
  const [f, setF] = useState(null);
  useEffect(() => { adminApi.get("/admin/settings/payment").then((r) => setF(r.data)); }, []);
  if (!f) return null;
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v }));
  const save = async () => {
    const r = await run(() => adminApi.put("/admin/settings/payment", f), "Payment settings saved");
    if (r) setF(r.data);
  };
  return (
    <Card title="Bank transfer & invoice instructions" testid="payment-settings">
      <div className="grid sm:grid-cols-2 gap-4">
        {BANK.map(([k, l]) => <TextInput key={k} label={l} value={f[k]} onChange={set(k)} testid={`payment-settings-${k.replace(/_/g, "-")}`} />)}
        <TextInput label="Reference instructions" value={f.reference_instructions} onChange={set("reference_instructions")} testid="payment-settings-reference" className="sm:col-span-2" />
        <TextArea label="Default payment instructions (used on new invoices)" rows={4} value={f.default_instructions} onChange={set("default_instructions")} testid="payment-settings-default-instructions" className="sm:col-span-2" />
      </div>
      <div className="mt-5 flex justify-end"><Btn onClick={save} data-testid="payment-settings-save">Save payment settings</Btn></div>
    </Card>
  );
};

export default function Settings() {
  return (
    <div className="space-y-8" data-testid="admin-settings">
      <PageTitle eyebrow="Configuration" title="Settings" />
      <BrandingCard />
      <PricingForm />
      <PaymentForm />
    </div>
  );
}
